module.exports = __webpack_public_path__ + "img/syimg6.1cf23340.png";